<div class="tw-pt-[30px] tw-flex tw-flex-col tw-gap-[42px]">
    <div
        class="tw-flex tw-flex-col tw-items-start md:tw-items-center tw-justify-center tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px] tw-gap-[18px]"
    >
        <span
            class="lg:tw-text-[28px] tw-text-[22px] tw-leading-[140%] tw-font-bold tw-text-[#024B3F] tw-gap-[18px] lg:tw-w-[748px] md:tw-w-[500px] tw-text-start md:tw-text-center tw-break-words tw-whitespace-normal"
            >{{ mainData?.title || "Title" }}</span
        >
        <span
            [innerHTML]="mainData?.description || 'Description'"
            class="tw-text-black tw-text-[14px] default-html tw-font-normal tw-leading-[22px] tw-items-start md:tw-items-center tw-gap-[18px] lg:tw-w-[748px] md:tw-w-[500px] tw-text-start md:tw-text-center tw-break-words tw-whitespace-normal"
        ></span>
    </div>
    <div>
        <app-sub-tabs
            [tabs]="tabs"
            mainTabSlug="financing-solutions"
            [selectedTab]="tabHandler.activeTab"
        ></app-sub-tabs>

        <!-- References to components -->
        <ng-template #step1>
            <app-step-1
                [products]="stepData[0]"
                [data]="finproData"
            ></app-step-1>
        </ng-template>
        <ng-template #step2>
            <app-step-2
                [products]="stepData[1]"
                [data]="grantsData"
            ></app-step-2>
        </ng-template>
        <ng-template #step3>
            <app-step-3
                [products]="stepData[2]"
                [data]="schemeData"
            ></app-step-3>
        </ng-template>
    </div>
</div>
